import { render } from "./PaymentCheckout.vue?vue&type=template&id=0a42dfea&scoped=true"
import script from "./PaymentCheckout.vue?vue&type=script&lang=ts"
export * from "./PaymentCheckout.vue?vue&type=script&lang=ts"

import "./PaymentCheckout.vue?vue&type=style&index=0&id=0a42dfea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a42dfea"

export default script